/** @module Apparel/NewStyleWizardromProject */
define([
    "dojo/_base/declare",
    "csi/wizard/ActionControllerMixin",
    "csi/xml",
    "./NewStyle",
    "./_StyleWizardMixIn"
], function (declare, ActionControllerMixin, xml, NewStyle, _StyleWizardMixIn) {

    const PROJECT_URL = "ProjectURL";
    return declare([NewStyle, ActionControllerMixin, _StyleWizardMixIn], {
        idWizardResource: "NewStyle",
        project:"",
        /**
         * @override
         * Allow user to Save & Go
         */
        _canRepeat: function () {
            return true;
        },

         _getNavigateNodeURL() {
             return this.getNode().Product;
        },

        /**
         * @override
         * Add ProjectURL to the server call
         */
        toWriterRequest: function() {
            let call = this.inherited(arguments);
            return call.addParameter(PROJECT_URL, xml.ATTR_REF, this.project);
        },

        /**
         * @override
         * Add ProjectURL to the server call
         */
        onCreatePopup: function(view) {
            this.project = this.m_urlParent;
            this.inherited(arguments);
        },

        /*
         * @override
         * Changing the URL for the changedNode Operations to be executed on.
         * In this case Product(Style) under the Project.ProjectLineItem.
        */
        toWriterFields(url) {
            this.inherited(arguments, [xml.getUrlPath(url, "Child:Product")]);
        }
    });
});
